import * as React from 'react';
import Component from '../../AbstractComponent';
import Constants from '../../../Action/Constants';
import { connect } from 'react-redux';
import { Attachment } from '../../Partials/Attachment/Attachment';
import { EntityAvatar } from '../../Partials/Avatar/EntityAvatar';
import { AddressSelector } from '../../Partials/AddressSelector/AddressSelector';
import { LeavePromptDialog } from '../../Partials/Dialog/LeavePromptDialog';
import PreventPageLeave from '../../../Middleware/Middlewares/PreventPageLeave';
import AgencyProfileWillMount from '../../../Middleware/Middlewares/AgencyProfileWillMount';
import { MiddlewareInterface } from '../../../Middleware/MiddlewareInterface';
import AgencyFeeContainer from '../../../Entity/Entities/AgencyFee/AgencyFeeContainer';
import { DeleteEntityPrompt } from '../../Partials/Dialog/DeleteEntityPrompt';
import Formatter from '../../../Localization/Formatter';
import Select from '../../Partials/Material/Select';
import Menu from '@material-ui/core/Menu';
import MenuItem from '@material-ui/core/MenuItem';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import ListItemText from '@material-ui/core/ListItemText';
import Card from '@material-ui/core/Card';
import IconButton from '@material-ui/core/IconButton';
import TextField from '../../Partials/Material/TextField';
import Button from '@material-ui/core/Button';
import TableCell from '@material-ui/core/TableCell';
import TableRow from '@material-ui/core/TableRow';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Switch from '@material-ui/core/Switch';
import Places from '../../../API/Google/Places';
import ExpansionPanel from '@material-ui/core/ExpansionPanel';
import ExpansionPanelDetails from '@material-ui/core/ExpansionPanelDetails';
import ExpansionPanelSummary from '@material-ui/core/ExpansionPanelSummary';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import { AgencyFeeInterface } from '../../../Entity/Entities/AgencyFee/AgencyFeeInterface';
// import { CoachAgencyFee } from "../../Partials/Dialog/CoachAgencyFee";
import { CompanyInterface } from '../../../Entity/Entities/Company/CompanyInterface';
import { PersonInterface } from '../../../Entity/Entities/Person/PersonInterface';
import PersonLookup from '../../Partials/Lookup/PersonLookup';
// import { TableComponent } from "../../Partials/Table/TableComponent";
import { PageTransition } from '../../Partials/Spinner/PageTransition';
// import CreatableSelect from 'react-select/creatable';
import Radio from '@material-ui/core/Radio';
import RadioGroup from '@material-ui/core/RadioGroup';
import Time from '../../../Time/Time';
import AssignmentServiceStatusTypeContainer from '../../../Entity/Entities/Unit/ServiceStatus/AssignmentServiceStatusTypeContainer';
// import { AgencyFeeInterface } from "../../../Entity/Entities/AgencyFee/AgencyFeeInterface";
import TypeContainer from '../../../Entity/Entities/Charge/Type/TypeContainer';
import PeriodContainer from '../../../Entity/Entities/Charge/Period/PeriodContainer';
import ReactSelect from 'react-select';
import Store from '../../../../Casadesk/Store/Store';
import Checkbox from '@material-ui/core/Checkbox';
import Environment from '../../../Environment/Environment';

class AgencyProfile extends Component {
  protected timerId: any;

  public state = {
    agency: null,
    settings: null,
    selectedAgencyFee: this.getAgency()?.defaultAgencyFees[0],
    email: '',
    name: '',
    shortName: '',
    phone: '',
    address: {
      formattedAddress: '',
    },
    defaultLocale: '',
    defaultLanguage: '',
    openLeavePrompt: false,
    isSaving: false,
    isUpdating: false,
    beta: false,
    // isAgencyFeeDialogOpen: false,
    nextPath: '',
    isAgencyRemoveDialog: false,
    agencyFee: null,
    anchorEl: null,
    attachments: [],
    mainBankAccountId: '',
    mainBankAccountName: '',
    note: '',
    notificationPeriod: 2,
    vatPercentage: '21',
    isBusy: false,
    bic: '',
    companyRegistry: '',
    vat: '',
    website: '',
    isAdmin: this.props.app?.session?.user?.isAdmin?.(),
    expanded: null,
    generalContactId: null,
    isActivateInvoiceNumber: false,
    reviewOwnerStatements: false,
    statementEmailTextEn: '',
    statementEmailTextNl: '',
    adjustRentEmailTextEN: '',
    adjustRentEmailTextNL: '',
    displayLess: true,
    displayMore: false,
    hasModifiedData: false,
    sendCopyToEmails: [],
    sendCopyToSubject: '',
    emailError: '',
    bankAccountError: '',
    generalContactError: '',
    invoiceEmailAddress: '',
    invoiceEmailSubject: '',
    defaultCalculation: '',
    useAgencyAsSenderForAutoEmails: true,
    isCopyEmailsNotValid: false,
    fixedFee: this.getAgency()?.defaultAgencyFees[0]?.fixedFee
      ? String(this.getAgency()?.defaultAgencyFees[0].fixedFee / 100)
      : '0',
    percentageFee: this.getAgency()?.defaultAgencyFees[0]?.percentageFee
      ? String(this.getAgency()?.defaultAgencyFees[0]?.percentageFee)
      : '',
    fixedPlusPercentageMode:
      this.getAgency()?.defaultAgencyFees[0]?.fixedPlusPercentageMode ||
      this.props.globalTypes?.FixedPlusPercentageModes?.[
        this.defaultFixedPlusPercentageModes('FPP_both')
      ],
    firstDate: Time.firstDateNextMonth(),
    dateChoice: this.getAgency()?.defaultAgencyFees[0]?.firstDate
      ? this.getAgency()?.defaultAgencyFees[0]?.firstDate
      : 'contractDate',
    chargeTypeIds: this.getAgency()?.defaultAgencyFees[0]?.chargeTypeIds || [
      TypeContainer.pickIdFromLabel('Basic_rent'),
    ],
    repeatPeriod:
      this.getAgency()?.defaultAgencyFees[0]?.repeatPeriod ||
      PeriodContainer.pickIdFromLabel('monthly'),
    assignmentServiceStatus:
      this.getAgency()?.defaultAgencyFees[0]?.assignmentServiceStatus ||
      AssignmentServiceStatusTypeContainer.pickIdFromLabel(
        'OperationalFinancial'
      ),
    date: Time.firstDateNextMonth(),
    currency: this.props.app.settings.user.currency.getCurrencyId(),
    invoiceEmailModified: false,
    agencyFeeModified: false,
  };

  protected shouldClearBeforeUnmounting: boolean = true;
  protected clearWith: string = Constants.PAGE_SETTINGS_AGENCY_PROFILE_CLEAR;
  protected middlewares: MiddlewareInterface[] = [
    AgencyProfileWillMount,
    PreventPageLeave,
  ];

  constructor(public props) {
    super(props);
  }

  public componentWillReceiveProps(nextProps) {
    const agency = nextProps?.app?.companies?.find(
      (company: CompanyInterface) => company?.isAgency
    );
    this.setState({
      isBusy: nextProps.app.settings.agency.isBusy,
      attachments: !!agency ? agency?.attachments : [],
      agency: agency,
    });
  }

  public changeLocale = (event) => {
    this.setState(
      {
        defaultLocale: event.target.value,
        hasModifiedData: true,
      },
      () => {
        this.saveSettings();
      }
    );
  };
  public newRelation(path: string, identifier: number[]): any {
    const pieces = path.split('.');
    const target = Object.keys(
      Store.getConfigurator().getState()[pieces[0]]?.[pieces[1]] || {}
    ).map(
      (id) => Store.getConfigurator().getState()[pieces[0]]?.[pieces[1]]?.[id]
    );

    return target.filter((entity) => {
      if (Array.isArray(identifier) === true) {
        return identifier.indexOf(entity.id) !== -1;
      }

      return entity.id === identifier;
    });
  }

  public getCompanyId() {
    const unit = this.newRelation('units.byId', this.props.objectId)[0];
    return unit?.property?.company.data.id;
  }
  public addAgencyFee(): any {
    const agencyFee = {
      objectType: this.state.isUpdating
        ? this.state.selectedAgencyFee?.objectType
        : AgencyFeeContainer.pickIdFromLabel('Agency'),
      objectId: this.state.isUpdating
        ? this.state.selectedAgencyFee?.objectId
        : this.getAgency()?.id,
      currency: this.state.currency,
      companyId: this.getCompanyId(),
      fixedFee: parseFloat(
        parseFloat(
          String(this.formatter.deleteExtraSpace(this.state.fixedFee)).replace(
            ',',
            '.'
          )
        ).toFixed(2)
      ),
      fixedPlusPercentageMode: this.state.fixedPlusPercentageMode.id,
      percentageFee: parseFloat(
        parseFloat(
          String(
            this.formatter.deleteExtraSpace(this.state.percentageFee)
          ).replace(',', '.')
        ).toFixed(2)
      ),
      vat: parseFloat(
        parseFloat(
          String(this.formatter.deleteExtraSpace(this.state.vat)).replace(
            ',',
            '.'
          )
        ).toFixed(2)
      ),
      firstDate:
        this.state.dateChoice === 'firstDate'
          ? Time.formatOrNull(this.state.firstDate)
          : null,
      chargeTypeIds: this.state.chargeTypeIds,
      repeatPeriodId: this.state.repeatPeriod,
      serviceStatusId: this.state.assignmentServiceStatus,
      date: Time.formatOrNull(this.state.date),
    };
    this.setState({
      isSaving: true,
    });
    this.props.dispatch({
      type: Constants.GLOBAL_AGENCY_FEE_CREATE_START,
      payload: agencyFee,
      onSuccess: () => {
        this.setState({
          isSaving: false,
          agencyFeeModified: false,
        });
      },
      onError: () => {
        this.setState({
          isSaving: false,
          agencyFeeModified: false,
        });
      },
    });
  }

  public saveAgencyFee = (): any => {
    const payload = {
      objectType: this.state.isUpdating
        ? this.state.selectedAgencyFee?.objectType
        : AgencyFeeContainer.pickIdFromLabel('Agency'),
      objectId: this.state.isUpdating
        ? this.state.selectedAgencyFee?.objectId
        : this.getAgency()?.id,
      currency: this.state.currency,
      companyId: this.getCompanyId(),
      fixedFee: parseFloat(
        parseFloat(
          String(this.formatter.deleteExtraSpace(this.state.fixedFee)).replace(
            ',',
            '.'
          )
        ).toFixed(2)
      ),
      fixedPlusPercentageMode: this.state.fixedPlusPercentageMode.id,
      percentageFee: parseFloat(
        parseFloat(
          String(
            this.formatter.deleteExtraSpace(this.state.percentageFee)
          ).replace(',', '.')
        ).toFixed(2)
      ),
      vat: parseFloat(
        parseFloat(
          String(this.formatter.deleteExtraSpace(this.state.vat)).replace(
            ',',
            '.'
          )
        ).toFixed(2)
      ),
      firstDate:
        this.state.dateChoice === 'firstDate'
          ? Time.formatOrNull(this.state.firstDate)
          : null,
      chargeTypeIds: this.state.chargeTypeIds,
      repeatPeriodId: this.state.repeatPeriod,
      serviceStatusId: this.state.assignmentServiceStatus,
      date: Time.formatOrNull(this.state.date),
    };
    this.setState({
      isSaving: true,
    });
    this.props.dispatch({
      type: Constants.GLOBAL_AGENCY_FEE_UPDATE_START,
      payload: {
        ...payload,
        id: this.state.selectedAgencyFee?.id,
      },
      onSuccess: () => {
        this.setState({
          isSaving: false,
          agencyFeeModified: false,
        });
      },
      onError: () => {
        this.setState({
          isSaving: false,
          agencyFeeModified: false,
        });
      },
    });
  };

  public defaultFixedPlusPercentageModes(label) {
    const chargeClass = this.props.globalTypes?.FixedPlusPercentageModes;
    for (const key in chargeClass) {
      if (chargeClass[key].label === label) {
        return chargeClass[key].id;
      }
    }
  }

  public onChargeTypesSelectChange = (valArray) => {
    const types = !!valArray ? valArray.map((item) => item.value) : [];

    this.setState({
      chargeTypeIds: [...types],
      hasModifiedData: true,
    });
  };

  public changeLanguage = (event) => {
    this.setState(
      {
        defaultLanguage: event.target.value,
        hasModifiedData: true,
      },
      () => {
        this.saveSettings();
      }
    );
  };

  public changeInvoiceEmailSubject = (event) => {
    this.setState({
      invoiceEmailSubject: event.target.value,
      hasModifiedData: true,
      invoiceEmailModified: true,
    });
  };

  public changeInvoiceEmailAddress = (e) => {
    this.setState({
      invoiceEmailAddress: e.target.value,
      hasModifiedData: true,
      invoiceEmailModified: true,
    });
  };

  public changeEmailSender = (e) => {
    this.setState({
      useAgencyAsSenderForAutoEmails: e.target.value,
      hasModifiedData: true,
    });
  };

  public changeCalculation = (event) => {
    this.setState(
      {
        defaultCalculation: event.target.value,
        hasModifiedData: true,
      },
      () => {
        this.saveSettings();
      }
    );
  };

  public changeNotificationPeriod = (event) => {
    this.setState({
      notificationPeriod: Number(event.target.value),
      hasModifiedData: true,
    });
  };

  public changeDateChoice = (event: any): void => {
    const choice: string = event.target.value;

    this.setState({
      dateChoice: choice,
      hasModifiedData: true,
    });
  };

  public changeVatPercentage = (event) => {
    this.setState({
      vatPercentage: Number(event.target.value),
      hasModifiedData: true,
    });
  };

  public updateFPPMode(event) {
    const fpp =
      this.props.globalTypes?.FixedPlusPercentageModes?.[event.target.value];

    this.setState({
      fixedPlusPercentageMode: fpp,
      hasModifiedData: true,
      agencyFeeModified: true,
    });
  }

  public switchReviewOwnerStatements = () => {
    this.setState(
      {
        reviewOwnerStatements: !this.state.reviewOwnerStatements,
      },
      this.saveSettings
    );
  };

  public saveSettings = (): any => {
    this.saving(() => {
      return this.props.dispatch({
        type: Constants.PAGE_SETTINGS_AGENCY_PROFILE_UPDATE_SETTINGS_START,
        payload: {
          preferences: {
            defaultLocale: this.state.defaultLocale,
            defaultLanguage: this.state.defaultLanguage,
            defaultCalculation: this.state.defaultCalculation,
            notificationPeriod: this.state.notificationPeriod,
            vatPercentage: this.state.vatPercentage,
            isActivateInvoiceNumber: this.state.isActivateInvoiceNumber,
            reviewOwnerStatements: this.state.reviewOwnerStatements,
            statementEmailTextEn: this.state.statementEmailTextEn,
            statementEmailTextNl: this.state.statementEmailTextNl,
            adjustRentEmailTextEN: this.state.adjustRentEmailTextEN,
            adjustRentEmailTextNL: this.state.adjustRentEmailTextNL,
            sendCopyToEmails: this.state.sendCopyToEmails,
            sendCopyToSubject: this.state.sendCopyToSubject,
            useAgencyAsSenderForAutoEmails:
              this.state.useAgencyAsSenderForAutoEmails,
          },
        },
        onSuccess: (settings) => {
          Places.changeLanguage(
            settings && settings.defaultLanguage && settings.defaultLanguage.iso
          );

          this.setState(
            {
              isSaving: false,
              hasModifiedData: false,
              isCopyEmailsNotValid: false,
            },
            () => {
              if (this.state.nextPath) {
                return this.redirect(this.state.nextPath);
              }
            }
          );
        },
        onError: (err) => {
          if (err.fields && err.fields.length) {
            const fields = err.fields;
            const match = fields.find((element) => {
              if (element.includes('sendCopyToEmails')) {
                return true;
              }
            });
            if (match) {
              this.setState({
                isCopyEmailsNotValid: true,
                isSaving: false,
                hasModifiedData: true,
              });
            } else {
              this.setState({
                isCopyEmailsNotValid: false,
                isSaving: false,
                hasModifiedData: true,
              });
            }
          }
        },
      });
    });
  };

  public saveAgencySettings = (): any => {
    if (!this.state.isAdmin) {
      return this.props.dispatch({
        type: Constants.SNACKBAR_ADD_MESSAGE,
        payload: {
          message: this.trans('preprocess/cantcreateactivitytemplate-info'),
          type: 'warning',
        },
      });
    }
    this.saving(() => {
      if (
        !this.getAgency()?.defaultAgencyFees[0] &&
        this.state.agencyFeeModified
      ) {
        this.addAgencyFee();
      } else if (this.state.agencyFeeModified) {
        this.saveAgencyFee();
      }
      if (this.state.invoiceEmailModified) {
        this.saveInvoiceEmail();
      }

      return this.props.dispatch({
        type: Constants.PAGE_SETTINGS_AGENCY_PROFILE_UPDATE_SETTINGS_START,
        payload: {
          preferences: {
            defaultLocale: this.state.defaultLocale,
            defaultLanguage: this.state.defaultLanguage,
            defaultCalculation: this.state.defaultCalculation,
            notificationPeriod: this.state.notificationPeriod,
            vatPercentage: this.state.vatPercentage,
            isActivateInvoiceNumber: this.state.isActivateInvoiceNumber,
            reviewOwnerStatements: this.state.reviewOwnerStatements,
            statementEmailTextEn: this.state.statementEmailTextEn,
            statementEmailTextNl: this.state.statementEmailTextNl,
            adjustRentEmailTextEN: this.state.adjustRentEmailTextEN,
            adjustRentEmailTextNL: this.state.adjustRentEmailTextNL,
            sendCopyToEmails: this.state.sendCopyToEmails,
            sendCopyToSubject: this.state.sendCopyToSubject,
            useAgencyAsSenderForAutoEmails:
              this.state.useAgencyAsSenderForAutoEmails,
          },
        },
        onSuccess: (settings) => {
          Places.changeLanguage(
            settings && settings.defaultLanguage && settings.defaultLanguage.iso
          );

          this.setState(
            {
              isSaving: false,
              hasModifiedData: false,
              isCopyEmailsNotValid: false,
            },
            () => {
              if (this.state.nextPath) {
                return this.redirect(this.state.nextPath);
              }
            }
          );
        },
        onError: (err) => {
          if (err.fields && err.fields.length) {
            const fields = err.fields;
            const match = fields.find((element) => {
              if (element.includes('sendCopyToEmails')) {
                return true;
              }
            });
            if (match) {
              this.setState({
                isCopyEmailsNotValid: true,
                isSaving: false,
                hasModifiedData: true,
              });
            } else {
              this.setState({
                isCopyEmailsNotValid: false,
                isSaving: false,
                hasModifiedData: true,
              });
            }
          }
        },
      });
    });
  };

  public saveInvoiceEmail = (): any => {
    this.saving(() => {
      return this.props.dispatch({
        type: Constants.PAGE_CONTACT_COMPANY_UPDATE_START,
        payload: {
          id: this.getAgency()?.agencyId,
          company: {
            invoiceEmailAddress: this.state.invoiceEmailAddress,
            invoiceEmailSubject: this.state.invoiceEmailSubject,
          },
        },
        onSuccess: () => {
          // this.setState({ isSaving: false }, () => this.saveSettings())
          this.setState({
            isSaving: false,
            hasModifiedData: false,
            invoiceEmailModified: false,
          });
        },
        onError: (err) => {
          this.setState({
            isSaving: false,
            hasModifiedData: true,
            errorFields: err.fields,
          });
        },
      });
    });
  };

  public save = (): void => {
    // Remove errors from reducer first.
    this.props.dispatch({
      type: Constants.PAGE_CONTACT_COMPANY_UPDATE_CLEAR,
    });

    if (!this.state.isAdmin) {
      return this.props.dispatch({
        type: Constants.SNACKBAR_ADD_MESSAGE,
        payload: {
          message: this.trans('preprocess/cantcreateactivitytemplate-info'),
          type: 'warning',
        },
      });
    }

    // Check if bank account id or email is empty. (FE Validation)
    const isEmailEmpty = this.isFieldEmpty('email', this.state?.email);
    const isGeneralContactEmpty = this.isFieldEmpty(
      'generalContactId',
      this.state?.generalContactId
    );

    if (isEmailEmpty || isGeneralContactEmpty) {
      return this.setState({
        emailError: isEmailEmpty ? this.trans('this-field-is-required') : '',
        generalContactError: isGeneralContactEmpty
          ? this.trans('this-field-is-required')
          : '',
      });
    }

    this.saving(() => {
      this.setState({
        emailError: '',
        bankAccountError: '',
        generalContactError: '',
      });

      this.props.dispatch({
        type: Constants.PAGE_SETTINGS_AGENCY_PROFILE_UPDATE_START,
        payload: {
          id: this.getAgency()?.id,
          agency: {
            name: this.state.name,
            shortName: this.state.shortName,
            email: this.state.email,
            phone: this.state.phone,
            address: { ...this.state.address },
            mainBankAccountId: this.state.mainBankAccountId,
            mainBankAccountName: this.state.mainBankAccountName,
            bankAccount: {
              accountId: this.state.mainBankAccountId,
              name: this.state.mainBankAccountName,
            },
            note: this.state.note,
            bic: this.state.bic,
            companyRegistry: this.state.companyRegistry,
            vat: this.state.vat,
            website: this.state.website,
            generalContactId: this.state.generalContactId,
            // invoiceEmailAddress: this.state.invoiceEmailAddress,
            // invoiceEmailSubject: this.state.invoiceEmailSubject,
          },
        },
        onSuccess: () => {
          this.props.dispatch({
            type: Constants.PAGE_CONTACT_COMPANY_UPDATE_CLEAR,
          });
          this.setState({
            isSaving: false,
          });
          // return this.saveSettings();
        },
        onError: () => {
          this.setState({
            isSaving: false,
          });
        },
      });
    });
  };
  public changeFixedFeeAmount = (event): void => {
    let amount: string = event.target.value;
    amount = this.formatter.formatSigns(amount);

    if (this.state.vat) {
      let fixedFee: number = parseFloat(
        parseFloat(
          String(this.formatter.deleteExtraSpace(amount)).replace(',', '.')
        ).toFixed(2)
      );
      fixedFee = isNaN(fixedFee) ? 0 : fixedFee;

      let vatNumber: any = parseFloat(
        parseFloat(
          String(this.formatter.deleteExtraSpace(this.state.vat)).replace(
            ',',
            '.'
          )
        ).toFixed(2)
      );
      vatNumber = isNaN(vatNumber) ? 0 : vatNumber;

      let varPercentage = (vatNumber / (fixedFee - vatNumber)) * 100;

      return this.setState({
        vatPercentage: isFinite(varPercentage)
          ? this.formatter.simpleFormatNumber(
              Math.round(varPercentage),
              false,
              false
            )
          : '',
        fixedFee: amount,
        hasModifiedData: true,
        agencyFeeModified: true,
      });
    }

    if (this.state.vatPercentage) {
      let fixedFee: number = parseFloat(
        parseFloat(
          String(this.formatter.deleteExtraSpace(amount)).replace(',', '.')
        ).toFixed(2)
      );
      fixedFee = isNaN(fixedFee) ? 0 : fixedFee;

      let vatPercentageNumber: any = parseFloat(
        parseFloat(
          String(
            this.formatter.deleteExtraSpace(this.state.vatPercentage)
          ).replace(',', '.')
        ).toFixed(2)
      );
      vatPercentageNumber = isNaN(vatPercentageNumber)
        ? 0
        : vatPercentageNumber;

      const vatNumber =
        (fixedFee / (100 + vatPercentageNumber)) * vatPercentageNumber;

      return this.setState({
        vat: this.formatter.simpleFormatNumber(
          Math.round(vatNumber * 100 + Number.EPSILON) / 100,
          false
        ),
        fixedFee: amount,
        hasModifiedData: true,
      });
    }

    return this.setState({
      vat: '',
      vatPercentage: '',
      fixedFee: amount,
      hasModifiedData: true,
    });
  };
  public renderAgencyLogo = (): any => {
    const logoAttachments = this.state.attachments?.filter(
      (attachment) => attachment.isAvatar
    );

    return (
      <div style={{ width: '100%' }}>
        {logoAttachments?.length === 0 && (
          <div style={{ display: 'flex', justifyContent: 'center' }}>
            <div className="container_logo">
              <div className="container_watermark">
                {this.trans('your-logo-here')}
              </div>
            </div>
          </div>
        )}

        <Attachment
          {...this.props}
          typeOfComponent="shared"
          amazonFolderName={this.getAgency()?.amazonFolderName}
          relation="agencyId"
          entity={this.getAgency()}
          attachments={logoAttachments}
          onChangeAvatar={(avatar) =>
            (this.refs.EntityAvatar as any) &&
            (this.refs.EntityAvatar as any).change(avatar)
          }
          onLastImageDeleted={() =>
            (this.refs.EntityAvatar as any) &&
            (this.refs.EntityAvatar as any).revert()
          }
          updateParentState={(attachments) =>
            this.setState({ attachments: attachments })
          }
          withoutBottomMargin={true}
          coachPresentation={true}
          doNotAllowAddAttachment={logoAttachments?.length > 0}
          logoComponent={true}
          setNoChangeViewFlag={true}
          disabled={!this.state.isAdmin}
        />
      </div>
    );
  };

  public renderChargeTypesSelect = () => {
    const chargeTypes = TypeContainer.getChargeTypesForChargeTemplates(
      'agencyfee'
    )
      .filter((type) => {
        if (type.removed) {
          return false;
        }

        if (
          TypeContainer.pickIdFromLabel('Stub_receivable') === type.id ||
          TypeContainer.pickIdFromLabel('Stub_payable') === type.id
        ) {
          return false;
        }

        return true;
      })
      .map((type) => {
        return {
          value: type.id,
          label: this.formatter.checkTranslationType(
            this.trans(type?.label, {}, '', type?.system),
            type?.label,
            type?.system
          ),
        };
      });

    const customStyles = {
      control: (base, state) => {
        let borderColor = 'rgba(0, 0, 0, 0.23)';
        let boxShadow = 'none !important';
        let outlineColor = 'auto';

        if (state.isFocused) {
          borderColor = '#00BCD4 !important';
          boxShadow = '0 0 1px 1px #00BCD4 !important';
          outlineColor = '#00BCD4 !important';

          if (!!this.getErrorFor('chargeTypeIds')) {
            borderColor = '#f44336 !important';
            boxShadow = '0 0 1px 1px #f44336 !important';
            outlineColor = '#f44336 !important';
          }
        } else {
          if (!!this.getErrorFor('chargeTypeIds')) {
            borderColor = '#f44336 !important';
            outlineColor = '#f44336 !important';
          }
        }

        return {
          ...base,
          border: state.isFocused ? 'none !important' : 'auto',
          borderColor: borderColor,
          boxShadow: boxShadow,
          outlineColor: outlineColor,
          outlineStyle: state.isFocused ? 'auto !important' : 'auto',
          outlineWidth: state.isFocused ? '5px !important' : 'auto',
          '&:hover': {
            borderColor: !!this.getErrorFor('chargeTypeIds')
              ? '#f44336'
              : 'black',
          }, // border style on hover
        };
      },
    };

    return (
      <div style={{ position: 'relative', zIndex: 2 }}>
        <ReactSelect
          defaultValue={this.state.chargeTypeIds.map((id) =>
            chargeTypes.find((type) => type.value === id)
          )}
          isMulti
          options={chargeTypes}
          onChange={this.onChargeTypesSelectChange}
          styles={customStyles}
          placeholder={this.trans('dialog/agencyfee-field/chargetypes-label')}
          className="form-element scroll-to-charge-types"
        />
        {!!this.getErrorFor('chargeTypeIds') && (
          <div className="component-error-text">
            {this.getErrorFor('chargeTypeIds')}
          </div>
        )}
        <div
          className="hint-styles-dialog"
          style={{ margin: '-10px 0 10px 0' }}
        >
          {this.trans('dialog/agencyfee-info/chargetypes')}
        </div>
      </div>
    );
  };
  public clearBackEndErrors = () => {
    this.props.dispatch({
      type: Constants.COACH_ERRORS_CLEAR,
    });
  };

  public changeAssignmentServiceStatus = (event) => {
    const type: number = event.target.value;
    this.clearBackEndErrors();

    this.setState({
      assignmentServiceStatus: type,
      agencyFeeModified: true,
      repeatPeriod:
        type ===
        AssignmentServiceStatusTypeContainer.pickIdFromLabel('TenantSearch')
          ? PeriodContainer.pickIdFromLabel('once')
          : PeriodContainer.pickIdFromLabel('monthly'),
    });
  };

  public changePercentageFeeAmount = (event): void => {
    let amount: string = event.target.value;
    amount = this.formatter.formatSigns(amount);

    this.setState({
      percentageFee: amount,
      hasModifiedData: true,
      agencyFeeModified: true,
    });
  };
  public renderPreferences = (): any => {
    const generalPerson: PersonInterface = this.props.app.persons.find(
      (person: PersonInterface) => person?.id === this.state.generalContactId
    );

    return (
      <form style={{ marginLeft: '23px' }}>
        <h4
          className="card-title"
          style={{ marginLeft: '0', marginBottom: '0' }}
        >
          {this.trans('new-user')}
        </h4>
        <Select
          className="form-element full-size form-input scroll-to-defaultLocale correct-label-position"
          error={this.getErrorFor('defaultLocale')}
          disabled={!this.state.isAdmin}
          value={this.state.defaultLocale}
          onChange={this.changeLocale}
          htmlFor="defaultLocale"
          label={this.trans('default-locale')}
          name="defaultLocale"
          id="defaultLocale"
        >
          {this.getLocaleSelectboxes()}
        </Select>
        <Select
          className="form-element full-size form-input scroll-to-defaultLanguage correct-label-position"
          error={this.getErrorFor('defaultLanguage')}
          disabled={!this.state.isAdmin}
          value={this.state.defaultLanguage}
          onChange={this.changeLanguage}
          label={this.trans('default-language')}
          htmlFor="defaultLanguage"
          name="defaultLanguage"
          id="defaultLanguage"
        >
          {this.getLanguageSelectboxes()}
        </Select>
        <h4
          className="card-title"
          style={{ marginLeft: '0', marginBottom: '15px', marginTop: '35px' }}
        >
          {this.trans('broken-month-calculation')}
        </h4>
        <div className="info-text hint-styles hint-styles-closer">
          {this.trans('settings/agencyprofile-info/brokenmonthcalculation')}
        </div>
        <Select
          className="form-element full-size form-input scroll-to-defaultLanguage correct-label-position"
          error={this.getErrorFor('defaultCalculation')}
          disabled={!this.state.isAdmin}
          value={this.state.defaultCalculation}
          onChange={this.changeCalculation}
          label={this.trans('default-calculation')}
          htmlFor="defaultCalculation"
          name="defaultCalculation"
          id="defaultCalculation"
        >
          {this.getCalculationSelectboxes()}
        </Select>
        <div
          className="info-text hint-styles hint-styles-closer"
          style={{ marginBottom: '10px' }}
        >
          {this.trans('settings/agencyprofile-info/brokenmonthexplanation')}
        </div>
        <h4
          className="card-title"
          style={{ marginLeft: '0', marginBottom: '0', marginTop: '35px' }}
        >
          {this.trans('title-new-contract')}
        </h4>
        <TextField
          autoComplete="off"
          className="form-element full-size scroll-to-notificationPeriod"
          label={this.trans('settings/agencyprofile-label/notificationperiod')}
          value={this.state.notificationPeriod}
          onChange={this.changeNotificationPeriod}
          type="number"
          variant="standard"
          inputProps={{ min: '1', max: '6' }}
          error={!!this.getErrorFor('notificationPeriod')}
          disabled={!this.state.isAdmin}
        />
        {!!this.getErrorFor('notificationPeriod') && (
          <div className="component-error-text">
            {this.getErrorFor('notificationPeriod')}
          </div>
        )}
        <div
          className="info-text hint-styles hint-styles-closer"
          style={{ marginBottom: '10px' }}
        >
          {this.trans('settings/agencyprofile-info/notificationperiod')}
        </div>
        <h4
          className="card-title"
          style={{ marginLeft: '0', marginBottom: '0', marginTop: '35px' }}
        >
          {this.trans('new-invoice')}
        </h4>
        <TextField
          autoComplete="off"
          className="form-element full-size scroll-to-vatPercentage"
          label={this.trans('settings/agencyprofile-label/vat')}
          value={this.state.vatPercentage}
          onChange={this.changeVatPercentage}
          type="number"
          variant="standard"
          inputProps={{ min: '1', max: '99' }}
          error={!!this.getErrorFor('vatPercentage')}
          disabled={!this.state.isAdmin}
        />
        {!!this.getErrorFor('vatPercentage') && (
          <div className="component-error-text">
            {this.getErrorFor('vatPercentage')}
          </div>
        )}
        <div
          className="info-text hint-styles hint-styles-closer"
          style={{ marginBottom: '10px' }}
        >
          {this.trans('settings/agencyprofile-info/vat')}
        </div>

        <h4
          className="card-title"
          style={{ marginLeft: '0', marginBottom: '15px', marginTop: '35px' }}
        >
          {this.trans('settings/agencyprofile-info/invoices')}
        </h4>
        <div>
          <TextField
            defaultValue={this.getAgency()?.invoiceEmailAddress}
            className="form-element full-width scroll-to-email"
            label={this.trans('label-email-address')}
            type="email"
            autoComplete="email"
            fullWidth={true}
            onChange={this.changeInvoiceEmailAddress}
            variant="standard"
            error={!!this.getErrorFor('invoiceEmailAddress')}
          />
          {!!this.getErrorFor('invoiceEmailAddress') && (
            <div className="component-error-text">
              {this.getErrorFor('invoiceEmailAddress')}
            </div>
          )}
          <div
            className="info-text hint-styles hint-styles-closer"
            style={{ marginBottom: '10px' }}
          >
            {this.trans('settings/agencyprofile-info/invoices-hint')}
          </div>
        </div>
        <TextField
          className="form-element full-width scroll-to-email"
          label={this.trans('settings-email-subject')}
          type="text"
          fullWidth={true}
          defaultValue={this.getAgency()?.invoiceEmailSubject}
          onChange={this.changeInvoiceEmailSubject}
          variant="standard"
          error={!!this.props.component.message}
        />
        <h4
          className="card-title"
          style={{ marginLeft: '0', marginBottom: '15px', marginTop: '35px' }}
        >
          {this.trans('settings/agencyprofile-info/sender')}
        </h4>
        <div className="info-text hint-styles hint-styles-closer">
          {this.trans('settings/agencyprofile-info/sender-hint')}
        </div>

        <RadioGroup
          // className="filters-container"
          value={this.state.useAgencyAsSenderForAutoEmails?.toString()}
          onChange={this.changeEmailSender}
          style={{
            padding: '10px 0 0 10px',
            width: '500px',
            paddingLeft: '0px',
          }}
        >
          <FormControlLabel
            control={<Radio color="primary" />}
            value={'false'}
            label={`${this.trans(
              'settings/agencyprofile-info/sender-general-contact'
            )} ${
              generalPerson?.displayName ||
              `${generalPerson?.firstName} ${generalPerson?.lastName}`
            } ${generalPerson?.email}`}
            style={{ width: 'auto', fontSize: '16px', marginRight: '20px' }}
          />

          <FormControlLabel
            control={<Radio color="primary" />}
            value={'true'}
            label={`${this.trans(
              'settings/agencyprofile-info/sender-general-email'
            )} ${this.state.shortName} ${this.state.email}`}
            style={{ width: 'auto', fontSize: '16px', marginRight: '20px' }}
          />
        </RadioGroup>

        <FormControlLabel
          control={
            <Checkbox
              checked={this.state.reviewOwnerStatements}
              style={{ margin: '10px 0' }}
              onChange={this.switchReviewOwnerStatements}
              color="primary"
            />
          }
          label={this.trans('use-show-review-features')}
        />
        <div
          className="info-text hint-styles hint-styles-closer"
          style={{ marginBottom: '20px', marginTop: '-15px' }}
        >
          {this.trans('settings/agencyprofile-info/reviewfeatures')}
        </div>
        <h4
          className="card-title"
          style={{ marginLeft: '0', marginBottom: '15px', marginTop: '35px' }}
        >
          {this.trans('title-default-agency-fees')}
        </h4>

        <div className="info-text hint-styles hint-styles-closer">
          {this.trans('hint-default-agency-fees')}
        </div>

        <Select
          className="form-element full-size form-input scroll-to-unitTypeId correct-label-position"
          error={this.getErrorFor('assignmentServiceStatusId')}
          value={this.state.assignmentServiceStatus}
          onChange={this.changeAssignmentServiceStatus}
          htmlFor="assignmentServiceStatusId"
          label={this.trans(
            'page/unitupdate-section/info-changeunitservicestatus/label'
          )}
          name="assignmentServiceStatus"
          id="assignmentServiceStatus"
          style={{ width: '300px' }}
        >
          <MenuItem
            key={AssignmentServiceStatusTypeContainer.pickIdFromLabel(
              'TenantSearch'
            )}
            value={AssignmentServiceStatusTypeContainer.pickIdFromLabel(
              'TenantSearch'
            )}
            className="assignment-service-status-type-el"
          >
            {this.trans(
              `assignment_service_status_type_${AssignmentServiceStatusTypeContainer.pickLabelFromId(
                2
              ).toLowerCase()}`
            )}
          </MenuItem>
          <MenuItem
            key={AssignmentServiceStatusTypeContainer.pickIdFromLabel(
              'OperationalFinancial'
            )}
            value={AssignmentServiceStatusTypeContainer.pickIdFromLabel(
              'OperationalFinancial'
            )}
            className="assignment-service-status-type-el"
          >
            {this.trans(
              `assignment_service_status_type_${AssignmentServiceStatusTypeContainer.pickLabelFromId(
                5
              ).toLowerCase()}`
            )}
          </MenuItem>
          <MenuItem
            key={AssignmentServiceStatusTypeContainer.pickIdFromLabel(
              'Financial'
            )}
            value={AssignmentServiceStatusTypeContainer.pickIdFromLabel(
              'Financial'
            )}
            className="assignment-service-status-type-el"
          >
            {this.trans(
              `assignment_service_status_type_${AssignmentServiceStatusTypeContainer.pickLabelFromId(
                4
              ).toLowerCase()}`
            )}
          </MenuItem>
          <MenuItem
            key={AssignmentServiceStatusTypeContainer.pickIdFromLabel(
              'Operational'
            )}
            value={AssignmentServiceStatusTypeContainer.pickIdFromLabel(
              'Operational'
            )}
            className="assignment-service-status-type-el"
          >
            {this.trans(
              `assignment_service_status_type_${AssignmentServiceStatusTypeContainer.pickLabelFromId(
                3
              ).toLowerCase()}`
            )}
          </MenuItem>
        </Select>

        <TextField
          autoComplete="off"
          className="form-element full-width scroll-to-fixedFee"
          type="text"
          label={this.trans('dialog/agencyfee-field/fixedfee-label')}
          value={this.state.fixedFee}
          onChange={this.changeFixedFeeAmount}
          autoFocus={true}
          variant="standard"
          fullWidth={true}
          error={!!this.getErrorFor('fixedFee')}
        />
        {!!this.getErrorFor('fixedFee') && (
          <div className="component-error-text">
            {this.getErrorFor('fixedFee')}
          </div>
        )}

        <div
          className="hint-styles-dialog"
          style={{ margin: '-14px 0 10px 0' }}
        >
          {this.trans('dialog/agencyfee-info/amount')}
        </div>

        <TextField
          autoComplete="off"
          className="form-element full-width scroll-to-percentageFee"
          type="text"
          label={this.trans('dialog/agencyfee-field/percentagefee-label')}
          value={this.state.percentageFee}
          onChange={this.changePercentageFeeAmount}
          variant="standard"
          fullWidth={true}
          error={!!this.getErrorFor('percentageFee')}
        />
        {!!this.getErrorFor('percentageFee') && (
          <div className="component-error-text">
            {this.getErrorFor('percentageFee')}
          </div>
        )}
        <div
          className="hint-styles-dialog"
          style={{ margin: '-14px 0 10px 0' }}
        >
          {this.trans('dialog/agencyfee-info/percentagefee')}
        </div>
        {Number(this.state.percentageFee) > 0 && this.renderChargeTypesSelect()}

        {Number(this.state.percentageFee) > 0 && (
          <Select
            className="form-element full-size form-input scroll-to-fixedPlusPercentageMode correct-label-position"
            error={this.getErrorFor('fixedPlusPercentageMode')}
            value={this.state.fixedPlusPercentageMode.id}
            onChange={this.updateFPPMode}
            label={this.trans(
              'dialog/agencyfee-field/fixedpluspercentagemode-label'
            )}
            htmlFor="fixedPlusPercentageMode"
            name="fixedPlusPercentageMode"
            id="fixedPlusPercentageMode"
          >
            {Object.keys(
              this.props.globalTypes?.FixedPlusPercentageModes || {}
            ).map((fpp) => {
              let fpps =
                this.props.globalTypes?.FixedPlusPercentageModes?.[fpp];

              return (
                <MenuItem key={fpps.id} value={fpps.id}>
                  {this.formatter.checkTranslationType(
                    this.trans(fpps.label),
                    fpps.label
                  )}
                </MenuItem>
              );
            })}
          </Select>
        )}

        <Select
          className="form-element full-size form-input scroll-to-repeat-period correct-label-position"
          error={this.getErrorFor('repeat-period')}
          disabled={
            !!this.props.disabled ||
            this.state.assignmentServiceStatus ===
              AssignmentServiceStatusTypeContainer.pickIdFromLabel(
                'TenantSearch'
              )
          }
          value={this.state.repeatPeriod}
          onChange={this.sync.bind(this, this.syncronizers.REPEAT_PERIOD)}
          htmlFor="repeatPeriod"
          label={this.trans('dialog/defaultchargetemplates-field/period-label')}
          name="repeatPeriod"
          id="repeatPeriod"
        >
          {this.getRepeatPeriodAgreementSelectboxes(
            this.state.assignmentServiceStatus
          )}
        </Select>

        <h4
          className="card-title"
          style={{ marginLeft: '0', marginBottom: '15px', marginTop: '35px' }}
        >
          {this.trans('title-website-link')}
        </h4>
        <div className="info-text hint-styles hint-styles-closer">
          {this.trans('hint/title-website-link')}
        </div>
        <div
          style={{ marginTop: '10px' }}
        >{`${this.getUrl()}/login?role=tenant&agency=${
          this.getAgency()?.id
        }&agencyName=${this.getAgency()?.name?.replace(/ /g, '-')}`}</div>

        <Button
          variant="contained"
          color="primary"
          className="form-button"
          disabled={this.state.isSaving === true}
          onClick={this.saveAgencySettings}
          style={{ marginBottom: '15px', marginTop: '15px' }}
        >
          {this.state.isSaving === true
            ? this.trans('button-saving')
            : this.trans('button-save')}
        </Button>
      </form>
    );
  };

  public onChangeSendCopyToEmails = (valArray = []) => {
    const emails = !!valArray ? valArray.map((item) => item.value) : [];

    this.setState({
      sendCopyToEmails: emails,
      hasModifiedData: true,
    });
  };

  public renderStatementSettings = (): any => {
    // const emailList = this.state.sendCopyToEmails
    //   .map(email => {
    //     return ({
    //       value: email,
    //       label: email
    //     });
    //   }
    //   );

    // const customStyles = {
    //   control: (base, state) => {
    //     let borderColor = 'rgba(0, 0, 0, 0.23)';
    //     let boxShadow = 'none !important';
    //     let outlineColor = "auto";

    //     if (state.isFocused) {
    //       borderColor = "#00BCD4 !important";
    //       boxShadow = "0 0 1px 1px #00BCD4 !important";
    //       outlineColor = "#00BCD4 !important";

    //       if (!!this.getDetailErrorFor("to")) {
    //         borderColor = "#f44336 !important";
    //         boxShadow = "0 0 1px 1px #f44336 !important";
    //         outlineColor = "#f44336 !important";
    //       }
    //     } else {
    //       if (!!this.getDetailErrorFor("to")) {
    //         borderColor = "#f44336 !important";
    //         outlineColor = "#f44336 !important";
    //       }
    //     }

    //     return ({
    //       ...base,
    //       border: state.isFocused ? 'none !important' : "auto",
    //       borderColor: borderColor,
    //       boxShadow: boxShadow,
    //       outlineColor: outlineColor,
    //       outlineStyle: state.isFocused ? "auto !important" : "auto",
    //       outlineWidth: state.isFocused ? "5px !important" : "auto",
    //       '&:hover': {
    //         borderColor: !!this.getDetailErrorFor("to") ? '#f44336' : 'black',
    //       }, // border style on hover
    //     });
    //   }
    // }

    return (
      <form
        style={{
          marginLeft: '23px',
          display: 'flex',
          flexDirection: 'column',
          width: '60%',
        }}
      >
        <h4
          className="card-title"
          style={{ marginLeft: '0', marginBottom: '0', marginTop: '35px' }}
        >
          {this.trans(
            'settings/agencyprofile-section/ownerstatements-title/defaulttextforstatementemail'
          )}
        </h4>
        <div style={{ position: 'relative' }}>
          <p
            style={{
              position: 'absolute',
              left: '-25px',
              top: '-4px',
              color: '#848484',
            }}
          >
            NL
          </p>
          <TextField
            autoComplete="off"
            className="form-element full-size scroll-to-statementEmailTextNl"
            type="text"
            // label={this.trans("settings/agencyprofile-section/ownerstatements-label/statementemailtext") + "(NL)"}
            value={this.state.statementEmailTextNl}
            onChange={this.sync.bind(
              this,
              this.syncronizers.EVENT,
              'statementEmailTextNl'
            )}
            variant="standard"
            multiline
            rowsMax="25"
            error={!!this.getErrorFor('statementEmailTextNl')}
          />
        </div>

        <div style={{ position: 'relative' }}>
          <p
            style={{
              position: 'absolute',
              left: '-25px',
              top: '-4px',
              color: '#848484',
            }}
          >
            EN
          </p>
          <TextField
            autoComplete="off"
            className="form-element full-size scroll-to-statementEmailTextEn"
            type="text"
            // label={this.trans("settings/agencyprofile-section/ownerstatements-label/statementemailtext") + "(EN)"}
            value={this.state.statementEmailTextEn}
            onChange={this.sync.bind(
              this,
              this.syncronizers.EVENT,
              'statementEmailTextEn'
            )}
            variant="standard"
            multiline
            rowsMax="25"
            error={!!this.getErrorFor('statementEmailTextEn')}
          />
        </div>

        <h4
          className="card-title"
          style={{ marginLeft: '0', marginBottom: '0', marginTop: '35px' }}
        >
          {this.trans(
            'settings/agencyprofile-section/ownerstatements-title/defaulttextforadjustrentemail'
          )}
        </h4>
        <div style={{ position: 'relative' }}>
          <p
            style={{
              position: 'absolute',
              left: '-25px',
              top: '-4px',
              color: '#848484',
            }}
          >
            NL
          </p>
          <TextField
            autoComplete="off"
            className="form-element full-size scroll-to-adjustRentEmailTextNL"
            type="text"
            // label={this.trans("settings/agencyprofile-section/ownerstatements-label/statementemailtext") + "(NL)"}
            value={this.state.adjustRentEmailTextNL}
            onChange={this.sync.bind(
              this,
              this.syncronizers.EVENT,
              'adjustRentEmailTextNL'
            )}
            variant="standard"
            multiline
            rowsMax="25"
            error={!!this.getErrorFor('adjustRentEmailTextNL')}
          />
        </div>

        <div style={{ position: 'relative' }}>
          <p
            style={{
              position: 'absolute',
              left: '-25px',
              top: '-4px',
              color: '#848484',
            }}
          >
            EN
          </p>
          <TextField
            autoComplete="off"
            className="form-element full-size scroll-to-adjustRentEmailTextEN"
            type="text"
            // label={this.trans("settings/agencyprofile-section/ownerstatements-label/statementemailtext") + "(EN)"}
            value={this.state.adjustRentEmailTextEN}
            onChange={this.sync.bind(
              this,
              this.syncronizers.EVENT,
              'adjustRentEmailTextEN'
            )}
            variant="standard"
            multiline
            rowsMax="25"
            error={!!this.getErrorFor('adjustRentEmailTextEN')}
          />
        </div>

        {/* <h4 className="card-title" style={{ marginLeft: "0", marginBottom: "0", marginTop: "35px" }}>{this.trans("settings/agencyprofile-section/ownerstatements-title/sendcopyofattachments")}</h4>

        <span className="hint-styles" style={{ marginTop: "5px" }}>{this.trans("settings/agencyprofile-section/ownerstatements-hint/sendcopy")}</span>

        <div style={{ position: "relative", zIndex: 2 }}>
          <CreatableSelect
            isMulti
            defaultValue={emailList}
            options={emailList}
            onChange={this.onChangeSendCopyToEmails}
            styles={customStyles}
            placeholder={this.trans("settings/agencyprofile-section/ownerstatements-label/sendcopytoemails")}
            className="form-element scroll-to-sendCopyToEmails"
            minMenuHeight={40}
            maxMenuHeight={window.innerHeight - 280 < 40 ? 40 : window.innerHeight - 280}
          />
            {this.state.isCopyEmailsNotValid && <div className="component-error-text">{this.trans("be_ajv_not_validated")}</div>}
        </div>


        <TextField
          autoComplete="off"
          className="form-element full-size scroll-to-sendCopyToSubject"
          type="text"
          label={this.trans("label-subject")}
          value={this.state.sendCopyToSubject}
          onChange={this.sync.bind(this, this.syncronizers.EVENT, "sendCopyToSubject")}
          variant="standard"
          error={!!this.getErrorFor("sendCopyToSubject")}
        /> */}

        <Button
          variant="contained"
          color="primary"
          className="form-button"
          disabled={this.state.isSaving === true}
          onClick={this.saveSettings}
          style={{ marginBottom: '15px', width: '50px' }}
        >
          {this.state.isSaving === true
            ? this.trans('button-saving')
            : this.trans('button-save')}
        </Button>
      </form>
    );
  };

  public changeInvoiceNumberActive = () => {
    if (!this.state.isAdmin) {
      this.props.dispatch({
        type: Constants.SNACKBAR_ADD_MESSAGE,
        payload: {
          message: this.trans('preprocess/cantcreateactivitytemplate-info'),
          type: 'warning',
        },
      });
    } else {
      if (
        this.checkProcessIsBusy({
          action: 'setInvoicing',
          entityName: 'agency',
        })
      ) {
        this.openIsBusyPopup();
      } else {
        this.setState(
          {
            isActivateInvoiceNumber: !this.state.isActivateInvoiceNumber,
          },
          this.saveSettings
        );
      }
    }
  };

  public renderInvoiceNumberActivationDate = (): any => {
    return (
      <div className="row" style={{ marginLeft: '23px' }}>
        <div className="grid"></div>
        <div className="grid">
          <div>
            <p className="hint-styles">
              {this.trans(
                'page/settings-tab/agencyprofile-section/invoiceactivationdate-info'
              )}
            </p>
            <div>
              <FormControlLabel
                control={
                  <Switch
                    checked={this.state.isActivateInvoiceNumber}
                    onChange={this.changeInvoiceNumberActive}
                    color="primary"
                  />
                }
                label={this.trans('active')}
              />
            </div>
          </div>
        </div>
      </div>
    );
  };

  public openAgencyFeeDialog = () => {
    return this.setState({
      isAgencyFeeDialogOpen: true,
    });
  };

  public closeAgencyFeeDialog = () => {
    // sending empty error array to clear page errors
    this.props.dispatch({
      type: Constants.GLOBAL_AGENCY_FEE_CREATE_FAILURE,
      payload: {
        err: [],
      },
    });

    this.setState({
      isAgencyFeeDialogOpen: false,
      isUpdating: false,
    });
  };

  public updateAgencyFee = (agencyFee: AgencyFeeInterface): any => {
    if (!this.state.isAdmin) {
      this.props.dispatch({
        type: Constants.SNACKBAR_ADD_MESSAGE,
        payload: {
          message: this.trans('preprocess/cantcreateactivitytemplate-info'),
          type: 'warning',
        },
      });

      return;
    }

    this.setState(
      {
        selectedAgencyFee: agencyFee,
        isUpdating: true,
        anchorEl: null,
      },
      () => {
        this.openAgencyFeeDialog();
      }
    );
  };

  public delete = (): any => {
    const agencyFee = this.state.agencyFee;

    this.props.dispatch({
      type: Constants.GLOBAL_AGENCY_FEE_DELETE_START,
      payload: agencyFee,
      onSuccess: () => {
        this.setState({ isAgencyRemoveDialog: false, agencyFee: null });
      },
      onError: () => {
        this.setState({
          isAgencyRemoveDialog: false,
          agencyFee: null,
        });
      },
    });
  };

  public closePrompt = (): void => {
    this.setState({
      isAgencyRemoveDialog: false,
    });
  };

  public getAgencyFeeDialogTitle = (): string => {
    return this.trans('dialog/agencyfee-title');
  };

  protected openMenu = (event: any, agencyFee: AgencyFeeInterface): void => {
    this.setState({
      selectedAgencyFee: agencyFee,
      anchorEl: event.currentTarget,
    });
  };

  protected closeMenu = (): void => {
    this.setState({
      anchorEl: null,
    });
  };

  public getDefaultAgencyFees = () => {
    return this.getAgency()?.defaultAgencyFees?.map(
      (agencyFee: AgencyFeeInterface) => {
        return (
          <TableRow
            hover
            key={agencyFee.id}
            className={`clickable-entity`}
            onClick={() => {
              if (!this.state.isAdmin) {
                this.props.dispatch({
                  type: Constants.SNACKBAR_ADD_MESSAGE,
                  payload: {
                    message: this.trans(
                      'preprocess/cantcreateactivitytemplate-info'
                    ),
                    type: 'warning',
                  },
                });

                return;
              } else {
                this.updateAgencyFee(agencyFee);
              }
            }}
          >
            <TableCell></TableCell>
            <TableCell style={{ width: 'auto' }}>
              {this.formatter.formatNumber(
                agencyFee.fixedFee,
                agencyFee.currency
              )}
            </TableCell>
            <TableCell>{`${this.formatter.simpleFormatNumber(
              agencyFee.percentageFee,
              false
            )}%`}</TableCell>
            <TableCell>
              {Formatter.checkTranslationType(
                this.trans(agencyFee.fixedPlusPercentageMode.label),
                agencyFee.fixedPlusPercentageMode.label
              )}
            </TableCell>
            <TableCell
              onClick={(e) => {
                e.stopPropagation();
              }}
            >
              <div>
                <IconButton onClick={(e) => this.openMenu(e, agencyFee)}>
                  <div className="icon icon-ic-more-vert"></div>
                </IconButton>
                <Menu
                  id="simple-menu"
                  anchorEl={this.state.anchorEl}
                  open={
                    Boolean(this.state.anchorEl) &&
                    this.state.selectedAgencyFee?.id === agencyFee.id
                  }
                  onClose={this.closeMenu}
                  disableAutoFocusItem={true}
                  anchorOrigin={{
                    vertical: 'bottom',
                    horizontal: 'center',
                  }}
                  transformOrigin={{
                    vertical: 'top',
                    horizontal: 'left',
                  }}
                  getContentAnchorEl={null}
                >
                  <MenuItem
                    onClick={() =>
                      this.updateAgencyFee(this.state.selectedAgencyFee)
                    }
                  >
                    <ListItemIcon>
                      <div className="icon icon-ic-edit icon-color"></div>
                    </ListItemIcon>
                    <ListItemText>{this.trans('menuitem-open')}</ListItemText>
                  </MenuItem>
                  <MenuItem
                    className="delete-action"
                    onClick={() => {
                      if (!this.state.isAdmin) {
                        this.props.dispatch({
                          type: Constants.SNACKBAR_ADD_MESSAGE,
                          payload: {
                            message: this.trans(
                              'preprocess/cantcreateactivitytemplate-info'
                            ),
                            type: 'warning',
                          },
                        });

                        return;
                      }
                      this.setState({
                        agencyFee: this.state.selectedAgencyFee,
                        isAgencyRemoveDialog: true,
                        anchorEl: null,
                      });
                    }}
                  >
                    <ListItemIcon>
                      <div className="icon icon-ic-remove icon-color remove-icon"></div>
                    </ListItemIcon>
                    <ListItemText>{this.trans('menuitem-delete')}</ListItemText>
                  </MenuItem>
                </Menu>
              </div>
            </TableCell>
          </TableRow>
        );
      }
    );
  };

  public selectDate = (momentDate: any, identifier: string): any => {
    const date =
      !!momentDate && typeof momentDate.toDate === 'function'
        ? momentDate.toDate()
        : momentDate;
    this.setState({
      [identifier]: date,
    });
  };

  public handleChangeExpansionPanel = (panel) => (event, expanded) => {
    event;
    this.setState({
      expanded: expanded ? panel : false,
    });
  };

  public changeGeneralContact = (
    person: PersonInterface,
    isManuallySelected: boolean
  ) => {
    this.setState({
      generalContactId: person?.id,
      hasModifiedData: isManuallySelected
        ? isManuallySelected
        : this.state.hasModifiedData,
    });
  };

  public clearGeneralContact = () => {
    this.setState({
      generalContactId: null,
      hasModifiedData: true,
    });
  };

  public getUrl = () => {
    if (Environment.isProduction()) {
      return 'https://login.casadesk.com';
    }

    if (Environment.isStaging()) {
      return 'https://casadesk-login-stg.herokuapp.com';
    }

    return 'http://localhost:3000';
  };

  public render() {
    return (
      <div style={{ width: '100%' }}>
        <div className="no-margin-top no-margin-right">
          <ExpansionPanel
            className="expansion-panel"
            expanded={this.state.expanded === 'agencyProfile'}
            onChange={this.handleChangeExpansionPanel('agencyProfile')}
          >
            <ExpansionPanelSummary expandIcon={<ExpandMoreIcon />}>
              {
                <div className="expansion-panel-wrapper">
                  <div className="expansion-panel-title">
                    {this.trans('settings-agency-profile-panel')}
                  </div>
                  <div className="expansion-panel-subtitle">
                    {this.trans('settings-agency-profile-panel-subtitle')}
                  </div>
                </div>
              }
            </ExpansionPanelSummary>
            <ExpansionPanelDetails>
              <Card className="card">
                <div className="row">
                  <div className="grid align-icon-grid">
                    <EntityAvatar
                      {...this.props}
                      ref="EntityAvatar"
                      entityName="company"
                    />
                  </div>
                  <div className="grid">
                    <form>
                      <TextField
                        autoComplete="off"
                        className="form-element full-size scroll-to-name"
                        type="text"
                        label={this.trans('agency-profile-agency-name')}
                        value={this.state.name}
                        onChange={this.sync.bind(
                          this,
                          this.syncronizers.EVENT,
                          'name'
                        )}
                        autoFocus={true}
                        variant="standard"
                        error={!!this.getErrorFor('name')}
                        disabled={!this.state.isAdmin}
                      />
                      <TextField
                        autoComplete="off"
                        className="form-element full-size scroll-to-name"
                        type="text"
                        label={this.trans('label-short-name')}
                        value={this.state.shortName}
                        onChange={(e) => {
                          const shortName = e.target.value;

                          // maxLength === 11 because twilio support only 11 symbols for sender name
                          if (shortName.length > 32) {
                            return;
                          }

                          this.setState({
                            shortName: shortName,
                            hasModifiedData: true,
                          });
                        }}
                        variant="standard"
                        error={!!this.getErrorFor('shortName')}
                        disabled={!this.state.isAdmin}
                      />
                      {!!this.getErrorFor('shortName') && (
                        <div className="component-error-text">
                          {this.getErrorFor('shortName')}
                        </div>
                      )}
                      <div className="hint-styles-wrapper">
                        <span className="hint-styles">
                          {this.trans('hint-agency-short-name')}
                        </span>
                      </div>
                      <TextField
                        autoComplete="off"
                        className="form-element full-size scroll-to-email"
                        type="text"
                        label={this.trans('general-agency-label-email')}
                        value={this.state.email}
                        onChange={this.sync.bind(
                          this,
                          this.syncronizers.EVENT,
                          'email'
                        )}
                        variant="standard"
                        error={
                          !!this.getErrorFor('email') || this.state.emailError
                        }
                        disabled={!this.state.isAdmin}
                      />

                      {!!this.getErrorFor('email') && (
                        <div className="component-error-text">
                          {this.getErrorFor('email')}
                        </div>
                      )}
                      {!!this.state.emailError && (
                        <div className="component-error-text">
                          {this.state.emailError}
                        </div>
                      )}

                      <div>
                        <PersonLookup
                          {...this.props}
                          className="form-element full-size scroll-to-generalContactId"
                          autoFocus={false}
                          autoSelectId={
                            this.state.generalContactId
                              ? this.state.generalContactId
                              : null
                          }
                          isInlineBlock={true}
                          width="100%"
                          containerWidth="100%"
                          ref="PersonLookup"
                          floatingLabelText={this.trans(
                            'label/agency-general-contact'
                          )}
                          labelText={this.trans('label/agency-general-contact')}
                          onSelect={this.changeGeneralContact}
                          onClear={this.clearGeneralContact}
                          forceUpdatePage={true}
                          onlyUsers={true}
                          disableEntityCreation={true}
                          hideClickThroughLink={true}
                          error={
                            this.getErrorFor('generalContactId') ||
                            this.state.generalContactError
                          }
                          disabled={!this.state.isAdmin}
                        />
                        {!!this.getErrorFor('generalContactId') && (
                          <div className="component-error-text">
                            {this.getErrorFor('generalContactId')}
                          </div>
                        )}
                        {/* {!!this.state.generalContactError && <div className="component-error-text">{this.state.generalContactError}</div>} */}
                      </div>

                      {this.state.displayLess && (
                        <Button
                          color="primary"
                          onClick={() =>
                            this.setState({
                              displayMore: true,
                              displayLess: false,
                            })
                          }
                          style={{ width: '100%', marginTop: '10px' }}
                        >
                          {this.trans('button-show-more')}
                        </Button>
                      )}
                      {this.state.displayMore && (
                        <React.Fragment>
                          <TextField
                            autoComplete="off"
                            className="form-element full-size scroll-to-phone"
                            type="text"
                            label={
                              this.trans('agency-phone') +
                              this.trans('field/optional')
                            }
                            value={this.state.phone}
                            onChange={this.sync.bind(
                              this,
                              this.syncronizers.EVENT,
                              'phone'
                            )}
                            variant="standard"
                            error={!!this.getErrorFor('phone')}
                            disabled={!this.state.isAdmin}
                          />
                          {!!this.getErrorFor('phone') && (
                            <div className="component-error-text">
                              {this.getErrorFor('phone')}
                            </div>
                          )}
                          <AddressSelector
                            {...this.props}
                            name="address.googlePlaceId"
                            className="scroll-to-address"
                            searchText={
                              this.state.address.formattedAddress
                                ? this.state.address.formattedAddress
                                : null
                            }
                            selectedAddress={this.state.address}
                            onSelect={this.sync.bind(
                              this,
                              this.syncronizers.VALUE,
                              'address'
                            )}
                            onClear={this.sync.bind(
                              this,
                              this.syncronizers.VALUE,
                              'address',
                              {}
                            )}
                            labelText={this.trans('agency-general-address')}
                            disabled={!this.state.isAdmin}
                          />

                          <TextField
                            autoComplete="off"
                            // id="mainBankAccountId"
                            // name="mainBankAccountId"
                            className="form-element full-size scroll-to-createData.bankAccount.accountId"
                            type="text"
                            label={
                              this.trans('label-bank-account-id') +
                              this.trans('field/optional')
                            }
                            value={this.state.mainBankAccountId}
                            onChange={this.sync.bind(
                              this,
                              this.syncronizers.EVENT,
                              'mainBankAccountId'
                            )}
                            variant="standard"
                            // error={!!this.getErrorFor("createData.bankAccount.accountId") || this.state.bankAccountError}
                            // helperText={this.getErrorFor("createData.bankAccount.accountId")}
                            disabled={!this.state.isAdmin}
                          />

                          {!!this.state.bankAccountError && (
                            <div className="component-error-text">
                              {this.state.bankAccountError}
                            </div>
                          )}

                          <TextField
                            autoComplete="off"
                            // id="mainBankAccountName"
                            // name="mainBankAccountName"
                            className="form-element full-size scroll-to-mainBankAccountName"
                            type="text"
                            label={
                              this.trans('label-bank-account-name') +
                              this.trans('field/optional')
                            }
                            value={this.state.mainBankAccountName}
                            onChange={this.sync.bind(
                              this,
                              this.syncronizers.EVENT,
                              'mainBankAccountName'
                            )}
                            variant="standard"
                            error={!!this.getErrorFor('mainBankAccountName')}
                            helperText={this.getErrorFor('mainBankAccountName')}
                            disabled={!this.state.isAdmin}
                          />

                          <TextField
                            autoComplete="off"
                            id="bic"
                            name="bic"
                            className="form-element full-size scroll-to-bic"
                            type="text"
                            label={
                              this.trans('label-bic') +
                              this.trans('field/optional')
                            }
                            value={this.state.bic}
                            onChange={this.sync.bind(
                              this,
                              this.syncronizers.EVENT,
                              'bic'
                            )}
                            variant="standard"
                            error={!!this.getErrorFor('bic')}
                            disabled={!this.state.isAdmin}
                          />
                          {!!this.getErrorFor('bic') && (
                            <div className="component-error-text">
                              {this.getErrorFor('bic')}
                            </div>
                          )}
                          <TextField
                            autoComplete="off"
                            id="companyRegistry"
                            name="companyRegistry"
                            className="form-element full-size scroll-to-companyRegistry"
                            type="text"
                            label={
                              this.trans('label-company-registry') +
                              this.trans('field/optional')
                            }
                            value={this.state.companyRegistry}
                            onChange={this.sync.bind(
                              this,
                              this.syncronizers.EVENT,
                              'companyRegistry'
                            )}
                            variant="standard"
                            error={!!this.getErrorFor('companyRegistry')}
                            disabled={!this.state.isAdmin}
                          />
                          {!!this.getErrorFor('companyRegistry') && (
                            <div className="component-error-text">
                              {this.getErrorFor('companyRegistry')}
                            </div>
                          )}
                          <TextField
                            autoComplete="off"
                            id="vat"
                            name="vat"
                            className="form-element full-size scroll-to-vat"
                            type="text"
                            label={
                              this.trans('label-vat-number') +
                              this.trans('field/optional')
                            }
                            value={this.state.vat}
                            onChange={this.sync.bind(
                              this,
                              this.syncronizers.EVENT,
                              'vat'
                            )}
                            variant="standard"
                            error={!!this.getErrorFor('vat')}
                            disabled={!this.state.isAdmin}
                          />
                          {!!this.getErrorFor('vat') && (
                            <div className="component-error-text">
                              {this.getErrorFor('vat')}
                            </div>
                          )}
                          <TextField
                            autoComplete="off"
                            id="website"
                            name="website"
                            className="form-element full-size scroll-to-website"
                            type="text"
                            label={
                              this.trans('label-website') +
                              this.trans('field/optional')
                            }
                            value={this.state.website}
                            onChange={this.sync.bind(
                              this,
                              this.syncronizers.EVENT,
                              'website'
                            )}
                            variant="standard"
                            error={!!this.getErrorFor('website')}
                            disabled={!this.state.isAdmin}
                          />
                          {!!this.getErrorFor('website') && (
                            <div className="component-error-text">
                              {this.getErrorFor('website')}
                            </div>
                          )}
                          <TextField
                            autoComplete="off"
                            id="note"
                            name="note"
                            className="form-element full-size scroll-to-note"
                            type="text"
                            multiline={true}
                            rowsMax={10}
                            label={
                              this.trans('note') + this.trans('field/optional')
                            }
                            value={this.state.note}
                            onChange={this.sync.bind(
                              this,
                              this.syncronizers.EVENT,
                              'note'
                            )}
                            variant="standard"
                            error={!!this.getErrorFor('note')}
                            disabled={!this.state.isAdmin}
                          />
                          {!!this.getErrorFor('note') && (
                            <div className="component-error-text">
                              {this.getErrorFor('note')}
                            </div>
                          )}

                          <Button
                            color="primary"
                            onClick={() =>
                              this.setState({
                                displayMore: false,
                                displayLess: true,
                              })
                            }
                            style={{ width: '100%', marginTop: '10px' }}
                          >
                            {this.trans('button-show-less')}
                          </Button>
                        </React.Fragment>
                      )}

                      <Button
                        variant="contained"
                        color="primary"
                        className="form-button"
                        disabled={this.state.isSaving}
                        onClick={this.save}
                        style={{ marginBottom: '15px' }}
                      >
                        {this.state.isSaving === true
                          ? this.trans('button-saving')
                          : this.trans('button-save')}
                      </Button>
                    </form>
                  </div>
                </div>
              </Card>
            </ExpansionPanelDetails>
          </ExpansionPanel>
          <ExpansionPanel
            className="expansion-panel"
            expanded={this.state.expanded === 'agencyLogo'}
            onChange={this.handleChangeExpansionPanel('agencyLogo')}
          >
            <ExpansionPanelSummary expandIcon={<ExpandMoreIcon />}>
              {
                <div className="expansion-panel-wrapper">
                  <div className="expansion-panel-title">
                    {this.trans('agency-logo-section')}
                  </div>
                  <div className="expansion-panel-subtitle">
                    {this.trans('agency-logo-section-subtitle')}
                  </div>
                </div>
              }
            </ExpansionPanelSummary>
            <ExpansionPanelDetails>
              {this.renderAgencyLogo()}
            </ExpansionPanelDetails>
          </ExpansionPanel>
          <ExpansionPanel
            className="expansion-panel"
            expanded={this.state.expanded === 'agencyPreferences'}
            onChange={this.handleChangeExpansionPanel('agencyPreferences')}
          >
            <ExpansionPanelSummary expandIcon={<ExpandMoreIcon />}>
              {
                <div className="expansion-panel-wrapper">
                  <div className="expansion-panel-title">
                    {this.trans('agency-preferences')}
                  </div>
                  <div className="expansion-panel-subtitle">
                    {this.trans('settings-agency-preferences-panel-subtitle')}
                  </div>
                </div>
              }
            </ExpansionPanelSummary>
            <ExpansionPanelDetails>
              {this.renderPreferences()}
            </ExpansionPanelDetails>
          </ExpansionPanel>
          <ExpansionPanel
            className="expansion-panel"
            expanded={this.state.expanded === 'statementsSettings'}
            onChange={this.handleChangeExpansionPanel('statementsSettings')}
          >
            <ExpansionPanelSummary expandIcon={<ExpandMoreIcon />}>
              {
                <div className="expansion-panel-wrapper">
                  <div className="expansion-panel-title">
                    {this.trans(
                      'page/settings-tab/agencyprofile-section/statementssettings-title'
                    )}
                  </div>
                  <div className="expansion-panel-subtitle">
                    {this.trans(
                      'page/settings-tab/agencyprofile-section/statementssettings-subtitle'
                    )}
                  </div>
                </div>
              }
            </ExpansionPanelSummary>
            <ExpansionPanelDetails>
              {this.renderStatementSettings()}
            </ExpansionPanelDetails>
          </ExpansionPanel>
          <ExpansionPanel
            className="expansion-panel"
            expanded={this.state.expanded === 'invoiceactivationdate'}
            onChange={this.handleChangeExpansionPanel('invoiceactivationdate')}
          >
            <ExpansionPanelSummary expandIcon={<ExpandMoreIcon />}>
              {
                <div className="expansion-panel-wrapper">
                  <div className="expansion-panel-title">
                    {this.trans(
                      'page/settings-tab/agencyprofile-section/invoiceactivationdate-title'
                    )}
                  </div>
                  <div className="expansion-panel-subtitle">
                    {this.trans(
                      'page/settings-tab/agencyprofile-section/invoiceactivationdate-subtitle'
                    )}
                  </div>
                </div>
              }
            </ExpansionPanelSummary>
            <ExpansionPanelDetails>
              {this.renderInvoiceNumberActivationDate()}
            </ExpansionPanelDetails>
          </ExpansionPanel>
          {/* <ExpansionPanel className="expansion-panel" expanded={this.state.expanded === 'agencyfees'} onChange={this.handleChangeExpansionPanel('agencyfees')}>
            <ExpansionPanelSummary expandIcon={<ExpandMoreIcon />}>
              {
                <div className="expansion-panel-wrapper">
                  <div className="expansion-panel-title">{this.trans("title-default-agency-fees")}</div>
                </div>
              }
            </ExpansionPanelSummary>
            <ExpansionPanelDetails className="expansion-panel-details">
              <div className="expansion-panel-attachments-wrapper">
                <Card className="card no-padding">
                  <div className="label-container">
                    <h3 className="card-title">
                      {this.trans("title-default-agency-fees")}
                    </h3>

                    {
                      this.getAgency()?.defaultAgencyFees?.length === 0 && (
                        <Button
                          color="primary"
                          onClick={this.openAgencyFeeDialog}
                        >
                          {this.trans("button-add-agency-fee")}
                        </Button>
                      )
                    }

                    {this.state.isAgencyFeeDialogOpen && (
                      <CoachAgencyFee
                        {...this.props}
                        agencyFee={this.state.isUpdating ? this.state.selectedAgencyFee : null}
                        objectType={this.state.isUpdating ? this.state.selectedAgencyFee?.objectType : AgencyFeeContainer.pickIdFromLabel("Agency")}
                        objectId={this.state.isUpdating ? this.state.selectedAgencyFee?.objectId : this.getAgency()?.id}
                        onCancel={this.closeAgencyFeeDialog}
                        openCoach={this.state.isAgencyFeeDialogOpen}
                        showDates={true}
                      />
                    )}

                  </div>
                  <div>
                    <TableComponent
                      {...this.props}
                      entities={this.getAgency()?.defaultAgencyFees}
                      className="listing-table agency-fees-table"
                      subtitle={this.trans("section/agencyfee-info/defaultagencyfeesnotfound")}
                      disabled={!this.state.isAdmin}
                      rows={this.getDefaultAgencyFees()}
                      headers={["", this.trans("dialog/agencyfee-field/fixedfee-label"), this.trans("dialog/agencyfee-field/percentagefee-label"), this.trans("fixed-plus-percentage-mode"), ""]}
                    />
                  </div>
                </Card>
              </div>
            </ExpansionPanelDetails>
          </ExpansionPanel> */}
          <ExpansionPanel
            className="expansion-panel"
            expanded={this.state.expanded === 'attachemnts'}
            onChange={this.handleChangeExpansionPanel('attachemnts')}
          >
            <ExpansionPanelSummary expandIcon={<ExpandMoreIcon />}>
              {
                <div className="expansion-panel-wrapper">
                  <div className="expansion-panel-title">
                    {this.trans('title-attachments')}
                  </div>
                </div>
              }
            </ExpansionPanelSummary>
            <ExpansionPanelDetails className="expansion-panel-details">
              <div className="expansion-panel-attachments-wrapper">
                <Attachment
                  {...this.props}
                  typeOfComponent="shared"
                  title={this.trans('attachments-for-agency')}
                  amazonFolderName={this.getAgency()?.amazonFolderName}
                  relation="agencyId"
                  entity={this.getAgency()}
                  attachments={this.state.attachments}
                  onChangeAvatar={(avatar) =>
                    (this.refs.EntityAvatar as any) &&
                    (this.refs.EntityAvatar as any).change(avatar)
                  }
                  onLastImageDeleted={() =>
                    (this.refs.EntityAvatar as any) &&
                    (this.refs.EntityAvatar as any).revert()
                  }
                  updateParentState={(attachments) =>
                    this.setState({ attachments: attachments })
                  }
                  disabled={!this.state.isAdmin}
                  withoutBottomMargin={true}
                />
              </div>
            </ExpansionPanelDetails>
          </ExpansionPanel>
        </div>

        <LeavePromptDialog
          {...this.props}
          prioritizeClosing={true}
          onClose={() =>
            this.setState({ openLeavePrompt: false, nextPath: '' })
          }
          openLeavePrompt={this.state.openLeavePrompt}
          onDiscard={this.leave.bind(this)}
          onSave={() => {
            this.setState({ openLeavePrompt: false });
            this.save();
          }}
          hideCross={true}
          leavePrompt={true}
        />

        <DeleteEntityPrompt
          {...this.props}
          entityName={'agency-fee-remove-from-settings-page'}
          isOpen={this.state.isAgencyRemoveDialog}
          onCancel={this.closePrompt}
          onDelete={this.delete}
        />

        <PageTransition isSaving={this.state.isSaving} />
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    app: state.app,
    component: state.companyUpdate,
    globalTypes: state.globalTypes,
  };
};

export default connect(mapStateToProps)(AgencyProfile);
